import Badge from "react-bootstrap/Badge";

/**
 * Produto marcado como `maisVendido` no cadastro: selo cinza translúcido,
 * que funciona sobre qualquer foto.
 *
 * `overlay` posiciona o selo no canto superior esquerdo da foto: o pai precisa
 * ser `position-relative`. Sem foto, ele vai inline, junto do nome.
 */
export default function BestSellerBadge({ overlay = false }) {
  const position = overlay ? "best-seller-overlay" : "me-1";
  return (
    // bg="": no react-bootstrap 2 o padrão é bg="primary", que vem com
    // !important e cobriria o fundo cinza do selo.
    <Badge bg="" className={`best-seller-badge ${position}`}>
      <small>Mais Pedido</small>
    </Badge>
  );
}
